import '@hotwired/turbo-rails'
import './src/timezone.js'
import './src/turbo_confirm.js'
import './src/uploader.js'
import initSentry from './src/sentry'
import { application } from './controllers/application'
import DropdownController from './controllers/dropdown_controller.js'
import AttachmentsController from './controllers/attachments_controller.js'
import AttachmentsV2Controller from './controllers/attachmentsv2_controller.js'
import AutoFormController from './controllers/auto_form_controller.js'
import AutoFillController from './controllers/autofill_controller.js'
import ClipboardController from './controllers/clipboard_controller.js'
import GrowInputController from './controllers/grow_input_controller.js'
import MultiSubmitController from './controllers/multi_submit_controller.js'
import NestedFormController from './controllers/nested_form_controller.js'
import PriceInputController from './controllers/price_input_controller.js'
import ReadMoreController from './controllers/read_more_controller.js'
import SlideshowController from './controllers/slideshow_controller.js'
import SortableController from './controllers/sortable_controller.js'
import StripeController from './controllers/stripe_controller.js'
import ToastController from './controllers/toast_controller.js'
import ToggleController from './controllers/toggle_controller.js'
import GlobalController from './controllers/global_controller.js'
import StickyHeaderController from './controllers/sticky_header_controller.js'
import AccordionController from './controllers/accordion_controller.js'
import HighlightsController from './controllers/highlights_controller.js'
import TurboFrameModalController from './controllers/turbo_frame_modal_controller.js'
import PanzoomController from './controllers/panzoom_controller.js'
import AutoScrollController from './controllers/auto_scroll_controller.js'
import ExternalLinksController from './controllers/external_links_controller.js'

application.register('dropdown', DropdownController)
application.register("attachments", AttachmentsController)
application.register("attachmentsv2", AttachmentsV2Controller)
application.register("auto-form", AutoFormController)
application.register("auto-fill", AutoFillController)
application.register("auto-scroll", AutoScrollController)
application.register("clipboard", ClipboardController)
application.register("grow-input", GrowInputController)
application.register("multi-submit", MultiSubmitController)
application.register("nested-form", NestedFormController)
application.register("price-input", PriceInputController)
application.register("read-more", ReadMoreController)
application.register("slideshow", SlideshowController)
application.register("sortable", SortableController)
application.register("stripe", StripeController)
application.register("toast", ToastController)
application.register("toggle", ToggleController)
application.register("global", GlobalController)
application.register("sticky-header", StickyHeaderController)
application.register("accordion", AccordionController)
application.register("highlights", HighlightsController)
application.register("turbo-frame-modal", TurboFrameModalController)
application.register("panzoom", PanzoomController)
application.register("external-links", ExternalLinksController)

initSentry()